var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingPayCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: -6209.806,
    y1: -242.58,
    x2: -6208.806,
    y2: -242.58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M145.479 147.048c-1.945 12.807-13.003 22.62-26.353 22.62h-82.71a5.876 5.876 0 01-5.876-5.876V94.347a7.288 7.288 0 017.288-7.288h40.218M138.773 98.23a30.574 30.574 0 017.01 19.527"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 70.321,
    y1: 66.269,
    x2: 174.055,
    y2: 66.269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.311 95.11L72.117 70.288a7.402 7.402 0 014.073-9.642l70.495-28.622a7.402 7.402 0 019.642 4.073l15.932 39.241a7.402 7.402 0 01-4.073 9.642l-39.918 16.079",
    fill: "none",
    stroke: "url(#SVGID_1_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M97.306 72.551l-9.722 3.947a3.542 3.542 0 01-4.614-1.949l-1.264-3.114a3.542 3.542 0 011.949-4.614l9.722-3.947a3.542 3.542 0 014.614 1.949l1.264 3.114a3.542 3.542 0 01-1.949 4.614z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 87.157,
    y1: 84.045,
    x2: 102.052,
    y2: 84.045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M88.407 86.561l12.395-5.032"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 90.401,
    y1: 90.533,
    x2: 117.288,
    y2: 90.533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M91.651 95.484l24.387-9.902"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M137.45 86.243l24.388-9.902"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 105.428,
    y1: 76.627,
    x2: 120.323,
    y2: 76.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M106.678 79.143l12.395-5.032"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 123.491,
    y1: 69.293,
    x2: 138.386,
    y2: 69.293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M124.741 71.81l12.395-5.033"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 141.762,
    y1: 61.876,
    x2: 156.656,
    y2: 61.876
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M143.012 64.392l12.394-5.033"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M135.885 147.146c-.757 12.632-11.241 22.643-24.063 22.643H35.78a5.314 5.314 0 01-5.314-5.314v-68.51h81.357c12.794 0 23.26 9.966 24.058 22.559"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M151.446 146.235H119.7c-7.574 0-13.714-6.14-13.714-13.714 0-7.574 6.14-13.714 13.714-13.714h31.746c1.09 0 1.974.884 1.974 1.974v23.479a1.974 1.974 0 01-1.974 1.975z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 114.305,
    y1: 132.642,
    x2: 125.695,
    y2: 132.642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 132.642,
    r: 4.445,
    fill: "none",
    stroke: "url(#SVGID_7_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 51.832,
    y1: 106.183,
    x2: 54.332,
    y2: 106.183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.082 103.179v6.008"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 51.832,
    y1: 119.753,
    x2: 54.332,
    y2: 119.753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_9_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.082 116.749v6.008"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 51.832,
    y1: 133.117,
    x2: 54.332,
    y2: 133.117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_10_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.082 130.113v6.008"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 51.832,
    y1: 146.687,
    x2: 54.332,
    y2: 146.687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_11_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.082 143.682v6.009"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c",
    gradientUnits: "userSpaceOnUse",
    x1: 51.832,
    y1: 159.846,
    x2: 54.332,
    y2: 159.846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_12_1b23a67be69ced7160f29ebdb61d564bb1b43db61e1af805928559ef7806534c)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.082 156.842v6.008"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingPayCard);
export default __webpack_public_path__ + "static/media/billingPayCard.edd45e4cef2cd9506cf9cde7f312cf5c.svg";
export { ForwardRef as ReactComponent };